import React from "react";
import { Paper } from "@mui/material";

interface ProvisoProps {
  content: string;
}

const Proviso: React.FC<ProvisoProps> = ({ content }) => {
  return (
    <Paper
      sx={{
        marginTop: 1.5,
        padding: 1.5,
        border: "2px dashed #aaa",
        fontSize: "0.9rem",
        lineHeight: 1.6,
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Paper>
  );
};

export default Proviso;
